import { RootState } from '../index';
import { EhrStatus } from '../../core/types/health.types';
import { VisitsState, ConditionsState } from '.';
import { StoreStatuses } from '../../core/types/common.types';

export const visitsSelector = (state: RootState): VisitsState => state.health.visits;

export const conditionsSelector = (state: RootState): ConditionsState => state.health.conditions;

export const isBusySelector = (state: RootState): boolean =>
  state.health.status === StoreStatuses.BUSY ||
  state.health.visits.status === StoreStatuses.BUSY ||
  state.health.conditions.status === StoreStatuses.BUSY;

export const healthErrorSelector = (state: RootState): boolean => state.health.error;

export const ehrStatusSelector = (state: RootState): EhrStatus => state.health.ehrStatus;
